import AboutUs from "Views/Authenticated/AboutUs";
import { Link } from "react-router-dom";

export const PUBLIC_ROUTES = [];
